export const appConstants = {
    downloadingQueue: {
        downloadingQueueLimit: 50,
    },
    firebaseError: {
        permDenied: "Permission denied",
    },
    localStorage: {
        fcmToken: "fcmToken",
        webcastUUID: "Webcast_UUID",
        refreshedOnInitialized: "refreshed_on_initialized",
        playlistMigrated: "playlistMigrated",
        loggedInUserMigrated: "loggedInUserMigrated",
        firstName: "firstName",
        lastName: "lastName",
        usernameSyncTime: "usernameSyncTime",
        encryptedTokensMigrated: "encryptedTokensMigrated",
        accessToken: "encryptedAccessToken",
        refreshToken: "encryptedRefreshToken",
        courseFirebaseToken: "encryptedCourseFirebaseToken",
        webcastsFirebaseToken: "encryptedWebcastsFirebaseToken",
        isResumeMigrated: "isResumeMigrated",
        isRedirectedToAmmwayConsentForm: "isRedirectedToAmmwayConsentForm",
        isLtdConsentFormOpened: "isLtdConsentFormOpened",
        isRedirectedToPurchaseBundlePage: "isRedirectedToPurchaseBundlePage",
        isRedirectedToBundleOptInPage: "isRedirectedToBundleOptInPage",
        isRedirectedToBundleSubsPage: "isRedirectedToBundleSubsPage",
        isRedirectingToSso: "isRedirectingToSso",
        resetConsentIndexDbStatus: "resetConsentIndexDbStatus",
        ngAccessToken: "ngAccesstoken",
        ngRefreshToken: "ngRefreshtoken",
        memberId: "memberId",
        aesGcmMigrated: "aesGcmMigrated",
        ngTokensAesGcmMigrated: "ngTokensAesGcmMigrated",
        snsTokenMigrated: "snsTokenMigrated",
    },
    sessionStorage: {
        chunkReloadAttempted: "chunkReloadAttempted",
    },
    ngEndpoints: {
        contentDetail: (nid: string) => `media/content/${nid}`,
        videoListing: (memberId: string) =>
            `media/users/${memberId}/videos/optimized`,
        audioListing: (memberId: string) =>
            `media/users/${memberId}/audios/optimized`,
        favoritesListing: (memberId: string) =>
            `/media/users/${memberId}/favorites`,
        markFavorite: "/media/mark-favorite",
        unmarkFavorite: "/media/un-mark-favorite",
        accessToken: "/oauth/user/token",
        refreshToken: "v1/users/token/refresh",
        availableCredits: (memberId: string) =>
            `/media/users/${memberId}/get-available-credits`,
        purchaseContent: "/media/purchase-content",
        redeemContent: "/media/redeem-content-for-self",
        redeemMultipleContent: "/media/redeem-multiple-content",
        confirmPurchase: "/media/confirm-purchase-content",
        purchasableGifts: (memberId: string) =>
            `/media/user/${memberId}/gifts/published`,
        groupMembers: (memberId: string, groupName: string) =>
            `/media/user/${memberId}/groups/${groupName}`,
        purchasedGifts: (memberId: string) =>
            `/media/user/${memberId}/gifts/purchased`,
        isProspectingUser: (memberId: string) =>
            `media/user/${memberId}/wasProspect`,
        sendGift: "/media/gifts/send",
        receivedGifts: (memberId: string) =>
            `/media/user/${memberId}/gifts/received`,
        userName: (memberId: string) => `/media/user/${memberId}`,
        syncDYS: (memberId: string) =>
            `/media/user/${memberId}/prospect/mapibo`,
        giftReceivers: (memberId: string) =>
            `/media/user/${memberId}/gifts/sent/receivers`,
        giftsSent: (senderId: string, receiverId: string) =>
            `/media/user/${senderId}/gifts/receivers/${receiverId}`,
        memberGiftQuantity: (memberId: string) =>
            `/media/user/${memberId}/gifts/remaining-quantity`,
        prospectGiftQuantity: (memberId: string) =>
            `/media/user/${memberId}/prospect/gifts/remaining-quantity`,
        externalSso: "sso/login/redirect",
        courseListing: (memberId: string) =>
            `/media/users/${memberId}/courses/optimized`,
        courseDetailWithMedia: (nid: string) =>
            `/media/course/detailWithMedia/${nid}`,
        courseDetailWithoutMedia: (nid: string) =>
            `/media/course/detailWithoutMedia/${nid}`,
        getPurchasedGiftCourses: (memberId: string) =>
            `/users/${memberId}/gifts/course/purchased`,
        postLtdConsent: `/media/user/consentForm`,
        getLtdConsent: (memberId: string) =>
            `/media/user/${memberId}/consentStatus`,
        getChecklistItems: (memberId: string) =>
            `/media/member/${memberId}/itemsCheckList`,
        checkChecklistItem: (memberId: string, itemNumber: string) =>
            `/media/member/${memberId}/itemsCheckList/${itemNumber}`,
        getBundleOptInStatus: (memberId: string) =>
            `/media/user/${memberId}/checkBundleOptIn`,
        getBundleSubscriptionStatus: (memberId: string) =>
            `/media/user/${memberId}/checkNewPaidMemberBundle`,
        getRecommendedMedia: (memberId: string) =>
            `/media/user/${memberId}/recommendations`,
        registerDeviceToken: (memberId: string) =>
            `/webPush/users/${memberId}/deviceToken`,
        updateDeviceToken: (memberId: string) =>
            `/webPush/users/${memberId}/deviceToken`,
        deleteDeviceToken: (memberId: string) =>
            `/webPush/users/${memberId}/deviceToken`,
        createPlaylist: (memberId: string) =>
            `/media/user/${memberId}/playlist`,
        getPlaylists: (memberId: string) => `/media/user/${memberId}/playlists`,
        deletePlaylist: (memberId: string, playlistId: number) =>
            `/media/user/${memberId}/playlist/${playlistId}`,
        renamePlaylist: (memberId: string, playlistId: number) =>
            `/media/user/${memberId}/playlist/${playlistId}`,
        sortPlaylist: (memberId: string) =>
            `/media/user/${memberId}/playlists/sort`,
        getRetiredContent: (memberId: string, types: string) =>
            `/media/users/${memberId}/retiredContents?contentTypes=${types}`,
        getBarCode: (memberId: string) => `/media/user/${memberId}/barcode`,
        getFycStatus: (memberId: string) => `/media/user/${memberId}/fcyStatus`,
        sendPush: `/webPush/sendPush`,
        getTeamInfo: (memberId: string) =>
            `/media/user/${memberId}/teamInformation`,
        getFirebaseToken: (memberId: string) =>
            `/v1/users/${memberId}/token/firebase/setup`,
        version: `/media/versionUpdate`,
        keys: `/media/keys`,
        contentUpdate: (memberId: string) =>
            `/media/users/${memberId}/contentUpdate`,
        login: `/v1/users/login`,
        disableJwtToken: (memberId: string) => `/v1/users/${memberId}/logout`,
        sso: `/sso/user/login`,
        attributes: (memberId: string) =>
            `media/user/${memberId}/contents/attributes`,
        pictureUrl: (memberId: string) => `/media/user/${memberId}/fileUrl`,
        playlistContent: (memberId: string, playlistId: string) =>
            `/media/user/${memberId}/playlist/${playlistId}/contents`,
        removeFromPlaylist: (
            memberId: string,
            playlistId: string,
            contentId: string,
        ) =>
            `/media/user/${memberId}/playlist/${playlistId}/content/${contentId}`,
        addToPlaylist: (
            memberId: string,
            playlistId: string,
            contentId: string,
        ) =>
            `/media/user/${memberId}/playlist/${playlistId}/content/${contentId}`,
        sortAudiosInPlaylist: (memberId: string, playlistId: string) =>
            `/media/user/${memberId}/playlist/${playlistId}/sort`,
        ssoRedirect: `/sso/redirect`,
        s3File: `/media/s3File`,
        paymentEligibleUser: (memberId: string) =>
            `/media/paymentEligibleUser?memberId=${memberId}`,
        betaUser: (memberId: string) => `/media/betaUser?memberId=${memberId}`,
        eventProfileImage: (userId: string) =>
            `/media/events/profileImage?userId=${userId}`,
        signedUrl: `/media/signedUrl`,
        thumbnailSignedUrls: `/media/thumbnails/signedUrls`,
        events: (memberId: string) => `/media/events?memberId=${memberId}`,
        webcasts: (memberId: string) => `/media/webcasts?memberId=${memberId}`,
        disclosures: `/content/disclosures`,
    },
};
export const nidControlTypes = [
    "offlinePlaylist",
    "audio",
    "video",
    "audioFavorite",
    "videoFavorite",
];

//in ms
export const PLAYER_PROGRESS_INTERVAL = 2000;

// an audiobook is only distinguishable from a bundle by its category title
export const AUDIOBOOK_CATEGORY_TITLE = "audiobook";
export const CONTENT_TILE_SIZE = 160;

export const pinPointConstants = {
    platform: "web",
    OptOutNone: "NONE",
    OptOutAll: "ALL",
};
